import styled from '@emotion/styled';
import { FormControlLabel } from '@mui/material';

export const StyledFormLabel = styled(FormControlLabel)`
  .MuiFormControlLabel-label {
    font-size: 12px;
    color: ${(props) => (props.disabled ? '#8A8A8A' : '#605f76')};
  }
`;
